import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme.component';
import { Routes, RouterModule } from '@angular/router';
import { UserAuthGuard } from '../auth/user/_guards/auth.guard';
import { PublisherUserAuthGuard } from '../auth/publisher-user/_guards/auth.guard';
import { PublisherAdminAuthGuard } from '../auth/publisher-user/_guards/admin.guard';
import { Paths } from '../models/enums';

const routes: Routes = [
    {
        path: '',
        component: ThemeComponent,
        //canActivate: [UserAuthGuard],
        children: [
            {
                canActivate: [PublisherUserAuthGuard],
                path: Paths.Publisher,
                loadChildren:
                './pages/default/publisher/dashboard/dashboard.module#DashboardModule'
            },
            {
                path: '',
                redirectTo: Paths.Publisher,
                pathMatch: 'full'
            },
            {
                path: '404',
                loadChildren:
                './pages/default/not-found/not-found.module#NotFoundModule'
            }
        ]
    },
    {
        path: Paths.Publisher,
        component: ThemeComponent,
        canActivate: [PublisherUserAuthGuard],
        children: [
            {
                path: '',
                loadChildren:
                './pages/default/publisher/dashboard/dashboard.module#DashboardModule'
            },
            {
                path: 'reservation',
                loadChildren:
                './pages/default/publisher/reservation/reservation.module#ReservationModule'
            },
            {
                path: 'inventory',
                loadChildren:
                './pages/default/shared/inventory/inventory.module#InventoryModule'
            },
            {
                path: 'inventory/site/create',
                loadChildren:
                './pages/default/shared/inventory/site/create-site/create-site.module#CreateSiteModule'
            },
            {
                path: 'inventory/site/update/:id',
                loadChildren:
                './pages/default/shared/inventory/site/update-site/update-site.module#UpdateSiteModule'
            },
            {
                path: 'inventory/page/create',
                loadChildren:
                './pages/default/shared/inventory/page/create-page/create-page.module#CreatePageModule'
            },
            {
                path: 'inventory/page/update/:id',
                loadChildren:
                './pages/default/shared/inventory/page/update-page/update-page.module#UpdatePageModule'
            },
            {
                path: 'inventory/adunit/create',
                loadChildren:
                './pages/default/shared/inventory/adunit/create-adunit/create-adunit.module#CreateAdUnitModule'
            },
            {
                path: 'inventory/adunit/update/:id',
                loadChildren:
                './pages/default/shared/inventory/adunit/update-adunit/update-adunit.module#UpdateAdUnitModule'
            },
            {
                path: 'publisherUser/list',
                canActivate: [PublisherAdminAuthGuard],
                loadChildren:
                './pages/default/shared/publisher-user/list-publisher-user/list-publisherUser.module#ListPublisherUserModule'
            },
            {
                path: 'publisherUser/create',
                canActivate: [PublisherAdminAuthGuard],
                loadChildren:
                './pages/default/shared/publisher-user/create-publisher-user/create-publisherUser.module#CreatePublisherUserModule'
            },
            {
                path: 'publisherUser/update/:id',
                canActivate: [PublisherAdminAuthGuard],
                loadChildren:
                './pages/default/shared/publisher-user/update-publisher-user/update-publisherUser.module#UpdatePublisherUserModule'
            },
            {
                path: 'usergroup/list',
                canActivate: [PublisherAdminAuthGuard],
                loadChildren:
                './pages/default/shared/user-group/list-user-group/list-user-group.module#ListUserGroupModule'
            },
            {
                path: 'usergroup/create',
                canActivate: [PublisherAdminAuthGuard],
                loadChildren:
                './pages/default/shared/user-group/create-user-group/create-user-group.module#CreateUserGroupModule'
            },
            {
                path: 'usergroup/update/:id',
                canActivate: [PublisherAdminAuthGuard],
                loadChildren:
                './pages/default/shared/user-group/update-user-group/update-user-group.module#UpdateUserGroupModule'
            },
            {
                path: 'customer/create',
                loadChildren:
                './pages/default/publisher/customer/create-customer/create-customer.module#CreateCustomerModule'
            },
            {
                path: 'customer/update/:id',
                loadChildren:
                './pages/default/publisher/customer/update-customer/update-customer.module#UpdateCustomerModule'
            },
            {
                path: 'customer/list',
                loadChildren:
                './pages/default/publisher/customer/list-customer/list-customer.module#ListCustomerModule'
            },
            {
                path: 'agency/create',
                loadChildren:
                './pages/default/publisher/agency/create-agency/create-agency.module#CreateAgencyModule'
            },
            {
                path: 'agency/update/:id',
                loadChildren:
                './pages/default/publisher/agency/update-agency/update-agency.module#UpdateAgencyModule'
            },
            {
                path: 'agency/list',
                loadChildren:
                './pages/default/publisher/agency/list-agency/list-agency.module#ListAgencyModule'
            },
            {
                path: 'systemmessage',
                canActivate: [PublisherAdminAuthGuard],
                loadChildren:
                './pages/default/publisher/system-message/system-message.module#SystemMessageModule'
            },
            {
                path: 'profile',
                loadChildren:
                './pages/default/publisher/profile/profile.module#ProfileModule'
            },
            {
                path: '404',
                loadChildren:
                './pages/default/not-found/not-found.module#NotFoundModule'
            },
            {
                path: '',
                redirectTo: Paths.Publisher,
                pathMatch: 'full'
            },
            {
                path: '**',
                redirectTo: '404',
                pathMatch: 'full'
            }
        ]
    },
    {
        path: Paths.Owner,
        component: ThemeComponent,
        canActivate: [UserAuthGuard],
        children: [
            {
                path: '',
                loadChildren:
                './pages/subheader--type-search/index/index.module#IndexModule'
            },
            {
                path: 'users/create',
                loadChildren:
                './pages/default/owner/owner-user/create-user/create-user.module#CreateUserModule'
            },
            {
                path: 'users/update/:id',
                loadChildren:
                './pages/default/owner/owner-user/update-user/update-user.module#UpdateUserModule'
            },
            {
                path: 'users/list',
                loadChildren:
                './pages/default/owner/owner-user/list-user/list-user.module#ListUserModule'
            },
            {
                path: 'publisher/create',
                loadChildren:
                './pages/default/owner/publishers/create-publisher/create-publisher.module#CreatePublisherModule'
            },
            {
                path: 'publisher/list',
                loadChildren:
                './pages/default/owner/publishers/list-publisher/list-publisher.module#ListPublisherModule'
            },
            {
                path: 'publisher/update/:id',
                loadChildren:
                './pages/default/owner/publishers/update-publisher/update-publisher.module#UpdatePublisherModule'
            },
            {
                path: 'publisherUser/create',
                loadChildren:
                './pages/default/shared/publisher-user/create-publisher-user/create-publisherUser.module#CreatePublisherUserModule'
            },
            {
                path: 'publisherUser/update/:id',
                loadChildren:
                './pages/default/shared/publisher-user/update-publisher-user/update-publisherUser.module#UpdatePublisherUserModule'
            },
            {
                path: 'usergroup/create',
                loadChildren:
                './pages/default/shared/user-group/create-user-group/create-user-group.module#CreateUserGroupModule'
            },
            {
                path: 'usergroup/update/:id',
                loadChildren:
                './pages/default/shared/user-group/update-user-group/update-user-group.module#UpdateUserGroupModule'
            },
            {
                path: 'publisher-detail/:id',
                loadChildren:
                './pages/default/owner/publisher-detail/publisher-detail.module#PublisherDetailModule'
            },
            {
                path: 'inventory',
                loadChildren:
                './pages/default/shared/inventory/inventory.module#InventoryModule'
            },
            {
                path: 'inventory/site/create',
                loadChildren:
                './pages/default/shared/inventory/site/create-site/create-site.module#CreateSiteModule'
            },
            {
                path: 'inventory/site/update/:id',
                loadChildren:
                './pages/default/shared/inventory/site/update-site/update-site.module#UpdateSiteModule'
            },
            {
                path: 'inventory/page/create',
                loadChildren:
                './pages/default/shared/inventory/page/create-page/create-page.module#CreatePageModule'
            },
            {
                path: 'inventory/page/update/:id',
                loadChildren:
                './pages/default/shared/inventory/page/update-page/update-page.module#UpdatePageModule'
            },
            {
                path: 'inventory/adunit/create',
                loadChildren:
                './pages/default/shared/inventory/adunit/create-adunit/create-adunit.module#CreateAdUnitModule'
            },
            {
                path: 'inventory/adunit/update/:id',
                loadChildren:
                './pages/default/shared/inventory/adunit/update-adunit/update-adunit.module#UpdateAdUnitModule'
            },
            {
                path: 'profile',
                loadChildren:
                './pages/default/owner/profile/profile.module#ProfileModule'
            },
            {
                path: 'setting/list',
                loadChildren:
                './pages/default/owner/setting/list-setting/list-setting.module#ListSettingModule'
            },
            {
                path: 'setting/update/:id',
                loadChildren:
                './pages/default/owner/setting/update-setting/update-setting.module#UpdateSettingModule'
            },
            {
                path: '404',
                loadChildren:
                './pages/default/not-found/not-found.module#NotFoundModule'
            },
            {
                path: '',
                redirectTo: Paths.Owner,
                pathMatch: 'full'
            },
            {
                path: '**',
                redirectTo: '404',
                pathMatch: 'full'
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ThemeRoutingModule { }

//export const routing: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/theme-routing.module.ts